export default __webpack_public_path__ + "static/media/LightingFix1.c7930c04.jpg";